const initNoveltiesTabsSlider = () => {
  const root = document.querySelector('[data-novelties-tabs]');

  if (!root || !window.Swiper) {
    return;
  }

  const delay = Number(root.dataset.delay) || 300;
  const swipers = [];

  root.querySelectorAll('[data-novelties-tabs-swiper]').forEach((container) => {
    const panel = container.closest('[data-tabs="element"]');

    if (!panel) {
      return;
    }

    const pagination = panel.querySelector('[data-novelties-tabs-pagination]');

    const swiper = new window.Swiper(container, {
      slidesPerView: 2,
      slidesPerGroup: 2,
      speed: 500,
      spaceBetween: 10,
      grabCursor: true,
      watchOverflow: true,
      resistanceRatio: 0.85,
      observer: true,
      observeParents: true,
      navigation: {
        prevEl: panel.querySelector('[data-slider-prev]'),
        nextEl: panel.querySelector('[data-slider-next]'),
      },
      pagination: pagination ? {el: pagination, clickable: true} : false,
      breakpoints: {
        808: {slidesPerView: 3, spaceBetween: 20},
        1200: {slidesPerView: 5, spaceBetween: 20},
      },
    });

    swipers.push(swiper);
  });

  const content = root.querySelector('[data-tabs="content"]');

  const syncHeight = () => {
    const activePanel = root.querySelector('[data-tabs="element"].is-active');

    if (!content || !activePanel) {
      return;
    }

    content.style.height = `${activePanel.offsetHeight}px`;
  };

  const updateSwipers = () => {
    swipers.forEach((swiper) => {
      swiper.update();
    });

    syncHeight();
  };

  root.querySelectorAll('[data-tabs="control"]').forEach((control) => {
    control.addEventListener('click', () => {
      window.setTimeout(updateSwipers, delay + 50);
    });
  });

  window.setTimeout(updateSwipers, 0);
};

export {initNoveltiesTabsSlider};
